import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const PaymentMade = () => {
    const navigate = useNavigate();

    const [category, setCategory] = useState([]);
    const [subcategory, setSubcategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubcategory, setSelectedSubcategory] = useState('');

    const [formData, setFormData] = useState({
        modeOfPayment: '',
        selectedCategory: '',
        selectedSubcategory: '',
        expensesType: '',
        expenses: '',
        amount: '',
        date: ''
    });

    // Fetch categories
    const getCategory = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/category/all-category/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            setCategory(response.data);
        } catch (error) {
            console.error("Error fetching category:", error);
        }
    };

    // Fetch subcategories based on selected category
    const getSubcategory = async (categoryId) => {
        try {
            const response = await axios.post('https://api.trucoo.in/category/subcategory/', {
                id: categoryId
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            setSubcategory(response.data);
        } catch (error) {
            console.error("Error fetching subcategory:", error);
        }
    };

    useEffect(() => {
        getCategory();
    }, []);

    // Load subcategories when selectedCategory changes
    useEffect(() => {
        if (selectedCategory) {
            getSubcategory(selectedCategory);
        }
    }, [selectedCategory]);

    // Handle changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCategoryChange = (e) => {
        const categoryId = e.target.value;
        setSelectedCategory(categoryId);
        setSelectedSubcategory('');
        setFormData({
            ...formData,
            selectedCategory: categoryId,
            selectedSubcategory: '',
            expensesType: ''
        });
    };

    const handleSubcategoryChange = (e) => {
        const selectedId = e.target.value;
        const selectedSub = subcategory.find(sub => sub.id == selectedId);
        setSelectedSubcategory(selectedId);
        setFormData({
            ...formData,
            selectedSubcategory: selectedId,
            expensesType: selectedSub ? selectedSub.subcategory : ''
        });
    };

    // Submit
    const handleSubmit = (e) => {
        e.preventDefault();

        const fullFormData = {
            ...formData,
            category: selectedCategory,
            subcategory: selectedSubcategory
        };

        console.log("Form Submitted: ", fullFormData);

        axios.post('https://api.trucoo.in/payment/allpaymentmade/', fullFormData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.data.status === "success") {
                    navigate('/PaymentMade');
                } else {
                    console.error(response.data);
                }
            })
            .catch(error => {
                console.error("There was an error submitting:", error);
            });
    };

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box box-body">
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div className="box">
                                        <div className="box-body">
                                            <h4 className="box-title text-primary mb-0"><i className="ti-user me-15"></i>Payment Made</h4>
                                            <hr className="my-15" />
                                            <div className="row">

                                                {/* Category */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Category</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={selectedCategory} 
                                                            onChange={handleCategoryChange} 
                                                            required
                                                        >
                                                            <option value="">Select Category</option>
                                                            {category.map((cat) => (
                                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Subcategory */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Expenses Type</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={selectedSubcategory} 
                                                            onChange={handleSubcategoryChange} 
                                                            required
                                                        >
                                                            <option value="">Select Expenses Type</option>
                                                            {subcategory.map((sub) => (
                                                                <option key={sub.id} value={sub.id}>{sub.subcategory}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Expenses */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Expenses</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Expenses Description"
                                                            name="expenses"
                                                            value={formData.expenses}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row align-items-center">
                                                    {/* Payment Mode */}
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-0">
                                                            <label className="form-label d-block">Payment Mode</label>
                                                            <div className="d-flex flex-row">
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        type="radio"
                                                                        id="radio_1"
                                                                        name="modeOfPayment"
                                                                        value="Cash"
                                                                        checked={formData.modeOfPayment === "Cash"}
                                                                        onChange={handleChange}
                                                                    />
                                                                    <label htmlFor="radio_1" className="ms-1">Cash</label>
                                                                </div>
                                                                <div className="form-check me-3">
                                                                    <input
                                                                        type="radio"
                                                                        id="radio_2"
                                                                        name="modeOfPayment"
                                                                        value="Bank"
                                                                        checked={formData.modeOfPayment === "Bank"}
                                                                        onChange={handleChange}
                                                                    />
                                                                    <label htmlFor="radio_2" className="ms-1">Bank</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Amount */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Amount</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter Amount"
                                                            name="amount"
                                                            value={formData.amount}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                {/* Date */}
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="form-label">Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="date"
                                                            value={formData.date}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="box-footer mt-20" align="center">
                                                <button type="button" className="btn btn-primary-light me-1" onClick={() => navigate('/PaymentMade')}>
                                                    <i className="ti-trash"></i> Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
                                                    <i className="ti-save-alt"></i> Save
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
};

export default PaymentMade;